var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39148 9.01019C6.84549 10.2484 4.58249 10.151 3.14936 8.71783C1.61167 7.18014 1.61167 4.68705 3.14936 3.14936C4.68705 1.61167 7.18014 1.61167 8.71783 3.14936C10.1509 4.58248 10.2484 6.84548 9.0102 8.39147L12.0176 11.3989C12.1885 11.5698 12.1885 11.8468 12.0176 12.0176C11.8468 12.1885 11.5698 12.1885 11.3989 12.0176L8.39148 9.01019ZM3.76808 8.09911C2.5721 6.90313 2.5721 4.96406 3.76808 3.76808C4.96406 2.5721 6.90313 2.5721 8.09911 3.76808C9.29421 4.96318 9.29509 6.90028 8.10174 8.09647C8.10086 8.09734 8.09998 8.09822 8.0991 8.09909C8.09822 8.09997 8.09735 8.10085 8.09648 8.10174C6.90029 9.29509 4.96318 9.29421 3.76808 8.09911Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/SearchBlack.59098c9114321e4b7144e590fce45293.svg";
export { ForwardRef as ReactComponent };